export enum FeeRangeTableColumns {
  MENU = "menu",
  FROM_AMOUNT = "fromAmount",
  TO_AMOUNT = "toAmount",
  NO_OF_FEES = "noOfFee",
  AMOUNT = "amount",
  DOUBLE_AMOUNT = "doubleAmount",
  BASE_AMOUNT = "baseAmount",
  REMINDER_FEE_RATE = "feeRate",
  FIXED_REMINDER_FEE_AMOUNT = "reminderFee",
  COLLECTION_FEE_AMOUNT = "collectionFee",
}

export const COLUMNS = [
  {
    id: 0,
    key: FeeRangeTableColumns.MENU,
    title: "",
  },
  {
    id: 1,
    key: FeeRangeTableColumns.FROM_AMOUNT,
    title: "US.COLLECTION.ADMIN:MANAGE_FEE.FROM_AMOUNT",
  },
  {
    id: 2,
    key: FeeRangeTableColumns.TO_AMOUNT,
    title: "US.COLLECTION.ADMIN:MANAGE_FEE.TO_AMOUNT",
  },
  {
    id: 3,
    key: FeeRangeTableColumns.BASE_AMOUNT,
    title: "US.COLLECTION.ADMIN:MANAGE_FEE.BASE_AMOUNT",
  },
  {
    id: 4,
    key: FeeRangeTableColumns.REMINDER_FEE_RATE,
    title: "US.COLLECTION.ADMIN:MANAGE_FEE.REMINDER_FEE_RATE",
  },
  {
    id: 5,
    key: FeeRangeTableColumns.FIXED_REMINDER_FEE_AMOUNT,
    title: "US.COLLECTION.ADMIN:MANAGE_FEE.REMINDER_FEE_AMOUNT",
  },
  {
    id: 6,
    key: FeeRangeTableColumns.COLLECTION_FEE_AMOUNT,
    title: "US.COLLECTION.ADMIN:MANAGE_FEE.COLLECTION_FEE_AMOUNT",
  },
];
